import * as tslib_1 from "tslib";
import { Model, RouteScope } from './../model';
import { WorkerViewPort } from './../viewPort';
var AppModel = (function (_super) {
    tslib_1.__extends(AppModel, _super);
    function AppModel(viewPort) {
        var _this = _super.call(this, 'app') || this;
        _this._appModel = _this;
        if (viewPort === undefined) {
            viewPort = new WorkerViewPort(_this);
        }
        _this._viewPort = viewPort;
        _this._routeScope = new RouteScope(_this);
        _this._descendantModels = {};
        _this._descendantModels[_this._id] = _this;
        _this._lastRefreshTime = 0;
        _this._refreshTimer = 0;
        _this.onRefresh = _this.onRefresh.bind(_this);
        return _this;
    }
    Object.defineProperty(AppModel.prototype, "appModel", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModel.prototype, "routeScope", {
        get: function () {
            return this._routeScope;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModel.prototype, "parentScope", {
        get: function () {
            return this._routeScope;
        },
        enumerable: true,
        configurable: true
    });
    AppModel.prototype.getModel = function (modelId) {
        return this._descendantModels[modelId];
    };
    AppModel.prototype.addDescendantModels = function (childModel, parentModel) {
        if (!this._descendantModels[childModel._id]) {
            this._descendantModels[childModel._id] = childModel;
            childModel.setAppModel(this);
        }
        for (var i = 0; i < childModel._childModels.length; i += 1) {
            this.addDescendantModels(childModel._childModels[i], childModel);
        }
    };
    AppModel.prototype.removeDescendantModels = function (childModel, parentModel) {
        for (var i = 0; i < childModel._childModels.length; i += 1) {
            this.removeDescendantModels(childModel._childModels[i], childModel);
        }
        if (this._descendantModels[childModel._id]) {
            childModel.setAppModel(null);
            delete this._descendantModels[childModel._id];
        }
    };
    AppModel.prototype.appendChildView = function (parentId, childId, viewDef) {
        if (arguments.length === 2) {
            viewDef = childId;
            childId = parentId;
            parentId = this._id;
        }
        this._viewPort.appendChild(parentId, childId, viewDef);
    };
    AppModel.prototype.prependChildView = function (parentId, childId, viewDef) {
        if (arguments.length === 2) {
            viewDef = childId;
            childId = parentId;
            parentId = this._id;
        }
        this._viewPort.prependChild(parentId, childId, viewDef);
    };
    AppModel.prototype.insertChildView = function (parentId, childId, targetId, viewDef) {
        if (arguments.length === 3) {
            viewDef = targetId;
            targetId = childId;
            childId = parentId;
            parentId = this._id;
        }
        this._viewPort.insertChild(parentId, childId, targetId, viewDef);
    };
    AppModel.prototype.removeChildView = function (parentId, childId) {
        if (arguments.length === 1) {
            childId = parentId;
            parentId = this._id;
        }
        this._viewPort.removeChild(parentId, childId);
    };
    AppModel.prototype.setState = function (newState, parentModel) {
        if (parentModel === undefined) {
            _super.prototype.setState.call(this, newState);
        }
        else {
            this._viewPort.setState(parentModel._id, newState);
        }
    };
    AppModel.prototype.requestRestate = function () {
        if ((this._flags & Model.REQUEST_RESTATE) === 0) {
            this._flags |= Model.REQUEST_RESTATE;
            if (!this._refreshTimer) {
                this._refreshTimer = setTimeout(this.onRefresh, 4);
            }
        }
    };
    AppModel.prototype.onRefresh = function () {
        this._refreshTimer = 0;
        if ((this._flags & Model.REQUEST_RESTATE) !== 0) {
            this.cascadeWillRestate();
            this.cascadeDidRestate();
        }
    };
    return AppModel;
}(Model));
export { AppModel };
Model.AppModel = AppModel;
//# sourceMappingURL=data:application/json;base64,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